import { api } from "./api";

export const listStoreProducts = async (params: any): Promise<any> => {
  const { data } = await api.get("products", { params });
  return data;
};

export const listStoreProductById = async (param: any): Promise<any> => {
  const { data } = await api.get(`products/${param}`);
  return data;
};

export const listStoreOrderItemById = async (id: any): Promise<unknown> => {
  const { data } = await api.get("order/item/" + id);
  return data;
};

export const listMarketplaceOnStores = async (): Promise<unknown> => {
  const { data } = await api.get("products/list/marketplace");
  return data;
};

export const updateMarketplaceOnStores = async (
  body: any
): Promise<unknown> => {
  const { data } = await api.put("products/update/marketplace", body);
  return data;
};

export const registerStoreProducts = async (body: any): Promise<unknown> => {
  const formData = new FormData();

  // 1. Adiciona as imagens
  for (const image of body.imgs) {
    // Certifique-se de que image é um File
    if (image instanceof File) {
      formData.append("files", image); // ou "files[]" se espera array
    }
  }

  // 2. Remove imgs do body
  delete body.imgs;

  if (body.dateEvent) {
    // 3. Converte campos simples
    body.dateEvent = String(body.dateEvent);
  }

  // 4. Adiciona os outros campos do body
  for (const key in body) {
    const value = body[key];
    if (value !== undefined && value !== null) {
      formData.append(key, String(value));
    }
  }

  // 5. Envia para o backend
  await api.post("/products", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return {};
};

export const updateStoreProducts = async (body: any): Promise<unknown> => {
  const formData: any = new FormData();

  // 1. Adiciona as imagens
  for (const image of body.imgs) {
    // Certifique-se de que image é um File
    if (image instanceof File) {
      formData.append("files", image); // ou "files[]" se espera array
    }
  }

  // 2. Remove imgs do body
  delete body.imgs;

  // 3. Converte campos simples
  if (body.dateEvent) {
    body.dateEvent = String(body.dateEvent);
  }

  // 4. Adiciona os outros campos do body
  for (const key in body) {
    const value = body[key];
    if (value !== undefined && value !== null) {
      formData.append(key, String(value));
    }
  }
  const { data } = await api.put("products/update", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const deleteStoreProducts = async (param: any): Promise<unknown> => {
  const { data } = await api.delete(`products/delete/${param}`);
  return data;
};

export const registerStoreOrders = async (body: any): Promise<unknown> => {
  const { data } = await api.post("/products/orders/create", body);
  return data;
};

export const listStoreOrders = async (): Promise<any> => {
  const { data } = await api.get("/products/orders/list");
  return data;
};

export const listByIdStoreOrders = async (id: any): Promise<any> => {
  const { data } = await api.get(`/products/orders/by-id/${id}`);
  return data;
};

export const cancelByIdStoreOrders = async (id: any): Promise<any> => {
  const { data } = await api.delete(`/products/orders/by-id/${id}`);
  return data;
};

export const ordersSettings = async (): Promise<any> => {
  const { data } = await api.get(`/products/orders/settings`);
  return data;
};
